import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EditBillingGroupContainer } from '@/features/billing-groups/containers/edit-billing-group';

const editBillingGroupSearch = z.object({
  id: z.number().catch(1),
  groupName: z.string().catch(''),
  discountTemplates: z
    .array(
      z.object({
        id: z.number(),
        code: z.string(),
        name: z.string(),
      }),
    )
    .catch([]),
});

export type EditBillingGroupSearch = z.infer<typeof editBillingGroupSearch>;

export const Route = createFileRoute('/_layout/billing-groups/edit')({
  component: EditBillingGroupContainer,
  validateSearch: search => editBillingGroupSearch.parse(search),
});
